export type HeatTier = 'cold' | 'warm' | 'hot' | 'on_fire' | 'blazing';

export interface HeatMeter {
  userId: string;
  currentStreak: number;
  currentTier: HeatTier;
  multiplier: number;
  progress: number; // Progress to next tier (0-1)
  lastUpdateTime: string;
  streakHistory: HeatStreakEvent[];
}

export interface HeatStreakEvent {
  timestamp: string;
  streakLength: number;
  tier: HeatTier;
  trigger: 'correct_pick' | 'incorrect_pick' | 'tier_up' | 'tier_down' | 'reset';
  gameId?: string;
}

export const HEAT_TIER_THRESHOLDS = {
  cold: { minStreak: 0, multiplier: 1.0 },
  warm: { minStreak: 3, multiplier: 1.25 },
  hot: { minStreak: 6, multiplier: 1.5 },
  on_fire: { minStreak: 9, multiplier: 2.0 },
  blazing: { minStreak: 12, multiplier: 3.0 },
} as const;

export interface HeatBonus {
  tier: HeatTier;
  multiplier: number;
  bonusPoints: number;
  triggerAnimation: boolean;
}

export interface HeatMeterUpdate {
  previousTier: HeatTier;
  newTier: HeatTier;
  previousStreak: number;
  newStreak: number;
  tierChanged: boolean;
  animation?: {
    type: 'tier_up' | 'tier_down' | 'on_fire' | 'blazing' | 'streak_broken';
    duration: number;
    effects: string[];
  };
}